import type { MiniFeatureProps, StripFeatureType } from "@/types/home-type";
import type { TranslationType } from "@/types/types";
import { Headphones, RotateCcw, ShieldCheck, Truck } from "lucide-react";

// hero
export const miniFeatures = (t: TranslationType): MiniFeatureProps[] => [
    {
        icon: ShieldCheck,
        label: t("home.hero.mini-feature.product_label"),
        desc: t("home.hero.mini-feature.product_desc"),
        withLine: true,
    },
    {
        icon: Truck,
        label: t("home.hero.mini-feature.shipping_label"),
        desc: t("home.hero.mini-feature.shipping_desc"),
        withLine: true,
    },
    {
        icon: Headphones,
        label: t("home.hero.mini-feature.cs_label"),
        desc: t("home.hero.mini-feature.cs_desc"),
        withLine: false,
    },
];

export const featuresHome = (t: TranslationType): StripFeatureType[] => [
    {
        icon: Truck,
        title: t("home.features.title_1"),
        subtitle: t("home.features.subtitle_1"),
    },
    {
        icon: ShieldCheck,
        title: t("home.features.title_2"),
        subtitle: t("home.features.subtitle_2"),
    },
    {
        icon: Headphones,
        title: t("home.features.title_3"),
        subtitle: t("home.features.subtitle_3"),
    },
    {
        icon: RotateCcw,
        title: t("home.features.title_4"),
        subtitle: t("home.features.subtitle_4"),
    },
];
